import { BaseGetRequest } from './core/baseGetRequest';
import {
    LoyaltyTermsAndConditionsMetaData,
    LoyaltyTermsAndConditionsMetaDataDynamicType
} from '../models/loyaltyTermsAndConditionsMetaData';
import { Authentication } from './core/baseRequest';

export class LoyaltyTermsAndConditionsMetaDataRequest extends BaseGetRequest<LoyaltyTermsAndConditionsMetaData> {
    constructor() {
        super(
            `loyalty-terms-and-conditions/meta-data`,
            {},
            LoyaltyTermsAndConditionsMetaDataDynamicType,
            Authentication.Login
        );
    }
}
